import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { configSelector } from "redux/selectors/config";
import {
  CardBox,
  SplitPanel,
  InformationText,
  Centered,
  VerticalPanel,
  PrimaryButton,
  ButtonWithTitle,
  CardTitle
} from "../CardsStyled";
import DropOutIcon from "../../Icons/DropOutIcon";
import useJourneyAbnormallyContent from "./hooks";
import { useTranslate } from "hooks/translation-hooks";

export const JourneyFinishedAbnormally = ({
  description,
  type,
  isCurrent,
  eventName
}) => {
  const t = useTranslate();
  const config = useSelector(configSelector);
  const {
    phoneNumber,
    descriptionText,
    onCallClicked
  } = useJourneyAbnormallyContent({
    type,
    config,
    description,
    isCurrent,
    eventName
  });
  const {
    show_button: showCallButton
  } = config.cards.journey_finished_abnormally;

  return (
    <CardBox data-category="dropout">
      <SplitPanel>
        <VerticalPanel>
          <Centered>
            <DropOutIcon />
          </Centered>
          <CardTitle>{t("dropout_card-title")}</CardTitle>
          <InformationText>{t(descriptionText)}</InformationText>
          <ButtonWithTitle>
            {showCallButton && (
              <>
                <InformationText>{t("dropout_card-text_2")}</InformationText>
                <a
                  data-testid="journey-finished-abnormally-contact-call"
                  href={`tel:${phoneNumber}`}
                  onClick={onCallClicked}
                >
                  <PrimaryButton>{phoneNumber}</PrimaryButton>
                </a>
              </>
            )}
          </ButtonWithTitle>
        </VerticalPanel>
      </SplitPanel>
    </CardBox>
  );
};

JourneyFinishedAbnormally.propTypes = {
  type: PropTypes.string,
  description: PropTypes.string,
  eventName: PropTypes.string,
  isCurrent: PropTypes.bool.isRequired
};

JourneyFinishedAbnormally.defaultProps = {
  type: "default",
  description: null,
  eventName: null
};

export default JourneyFinishedAbnormally;
